<script setup>
import { BOverlay } from 'bootstrap-vue-next';

import { store } from '~/store';

defineProps({
  show: {
    type: Boolean,
  },
});
</script>

<template>
  <BOverlay
    :variant="store.theme"
    :show="show"
    no-wrap
    fixed
  >
    <slot />
  </BOverlay>
</template>
